export default __webpack_public_path__ + "static/media/Belt of the Still Pond.d2e1cb93.jpg";